import { User } from "../types/admin";
import axios from "axios";
import { BaseApi } from "./BaseApi";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import setupInterceptors from "../config/axios";

export class ProjectApi extends BaseApi {
    constructor(account: AccountInfo, msalInstance: IPublicClientApplication) {
        super(account, msalInstance);
        setupInterceptors();
    }

    public async progressStatus(projectId: string): Promise<string> {
        await this.refreshToken();
        try {
            await axios.put(
                this.config.apiUrl + "/Project/ProgressStatus",
                { id: projectId },
                this.getDefaultHeaders()
            );
            return "success";
        } catch (error) {
            return "error";
        }
    }

    public async regressStatus(projectId: string, projectStatusTo: number | null, comment: string | null): Promise<string> {
        await this.refreshToken();
        try {
            await axios.put(
                this.config.apiUrl + "/Project/RegressStatus",
                {
                    id: projectId,
                    status: projectStatusTo,
                    reopeningDescription: comment
                },
                this.getDefaultHeaders()
            );
            return "success";
        } catch (error) {
            return "error";
        }
    }

    public async updateQuestionnaire(questionnaire: any): Promise<any> {
        await this.refreshToken();
        try {
            const response = await axios.post(
                this.config.apiUrl + "/Project/UpdateProject",
                questionnaire,
                this.getDefaultHeaders()
            );
            return response;
        } catch (error) {
            throw error;
        }
    }
}